<script lang="ts">
	import { _ } from 'svelte-i18n';
	import LoadingStore from './LoadingStore';
	import { fade } from 'svelte/transition';
</script>

{#if $LoadingStore}
	<div
		class="absolute bg-modal w-full h-full top-0 left-0 right-0 bottom-0 flex items-center justify-center"
		in:fade
		out:fade
	>
		<div class="relative flex flex-col items-center justify-center h-64 px-8 py-4">
			<div class="flex text-container pb-4 text-white">
				<p class="text-2xl font-bold">{$_('general.lbl_loading')}</p>
				<p class="dot-p text-2xl font-bold ml-2">.</p>
				<p class="dot-p-2 text-2xl font-bold">.</p>
				<p class="dot-p-3 text-2xl font-bold">.</p>
			</div>

			<div id="preloader" class="pb-4">
				<div id="loader"></div>
			</div>
		</div>
	</div>
{/if}

<style>
	.dot-p {
		animation: pulse 0.8s linear infinite;
	}

	.dot-p-2 {
		animation: pulse 0.8s linear infinite;
		animation-delay: 0.3s;
	}

	.dot-p-3 {
		animation: pulse 0.8s linear infinite;
		animation-delay: 0.7s;
	}

	#loader {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		border: 3px solid transparent;
		--tw-border-opacity: 1;
		border-top-color: rgb(44 58 73 / var(--tw-border-opacity, 1));
		animation: spin 2s linear infinite;
	}
	#loader:before {
		content: '';
		position: absolute;
		top: 5px;
		left: 5px;
		right: 5px;
		bottom: 5px;
		border-radius: 50%;
		border: 3px solid transparent;
		--tw-border-opacity: 1;
		border-top-color: rgb(23 137 192 / var(--tw-border-opacity, 1));
		animation: spin 3s linear infinite;
	}
	#loader:after {
		content: '';
		position: absolute;
		top: 15px;
		left: 15px;
		right: 15px;
		bottom: 15px;
		border-radius: 50%;
		border: 3px solid transparent;
		--tw-border-opacity: 1;
		border-top-color: rgb(45 218 255 / var(--tw-border-opacity, 1));
		animation: spin 1.5s linear infinite;
	}
	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes pulse {
		0% {
			transform: translatey(0px);
		}

		50% {
			transform: translatey(-5px);
		}
	}
</style>
